import styled from '@emotion/styled'

export const BorderDecoration = styled.div<{
  top: number | string
  left: number | string
  right: number | string
  bottom: number | string
}>`
  border: 2px solid var(--c-blue100);
  position: absolute;
  z-index: -1;

  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : top)};
  left: ${({ left }) => (typeof left === 'number' ? `${left}px` : left)};
  right: ${({ right }) => (typeof right === 'number' ? `${right}px` : right)};
  bottom: ${({ bottom }) => (typeof bottom === 'number' ? `${bottom}px` : bottom)};
`
